module.exports = __webpack_public_path__ + "media/img/icons-c1df815a.png";